import { render, staticRenderFns } from "./SimulationDataGeneration.vue?vue&type=template&id=c510328a&scoped=true&"
import script from "./SimulationDataGeneration.vue?vue&type=script&lang=js&"
export * from "./SimulationDataGeneration.vue?vue&type=script&lang=js&"
import style0 from "./SimulationDataGeneration.vue?vue&type=style&index=0&id=c510328a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c510328a",
  null
  
)

export default component.exports